module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAiBAMAAAAuQN21AAAALVBMVEUAAAD///////////////////////////////////////////////////////+hSKubAAAADnRSTlMAiCIz9fLVgB35lGtnGCiR2nEAAABmSURBVCjPY+Dxe4cGfBgYWN6hg6cMDHzvMAAOQU4MsZcMDFwYgq8YGBiUjdGAAsMAA45CQTRQwcDAhuH4Z1j9TrwgVjOx2z7Q4JISGrjAwMCI4fiH2OL9CfEBgiPVccehC0ZjdyUAdCwlxthRuPoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hamburger.png
// module id = DkvJ
// module chunks = 0